import "../../../../src/content/shjn-conference/shjn-conf.scss";
import * as React from 'react';
export default {
  React
};